import { createContext } from 'react';

const VirtualKeyboardContext = createContext<{
  listIndex: number;
  listFocused: boolean;
  onClick: (index?: number) => void;
}>({ listFocused: false, listIndex: -1, onClick: () => null });

export default VirtualKeyboardContext;
